<template>
  <div class="distribution-bar d-flex" style="width: 100%">
    <v-tooltip
      content-class="tool-tip elevation-5"
      bottom
      v-for="(val, i) in values"
      :key="`${val}_${i}`"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          :class="colors[i]"
          :style="get_styling(values, item[val], item)"
        ></div>
      </template>
      <div class="d-flex flex-column rounded">
        <div :class="`${colors[i]} pa-1 rounded-t`"></div>
        <div class="pa-2">
          <div>{{ labels[i] }}</div>
          <div class="font-weight-bold">
            {{ item[val] }} ({{ get_percentage(values, item[val], item) }})
          </div>
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "DistributionBarVT",
  props: { values: Array, item: Object, colors: Array, labels: Array },
  methods: {
    get_styling(items, current_val, value) {
      let total = 0;
      items.forEach((key) => {
        total = total + value[key];
      });
      return {
        height: "0.55em",
        width: (current_val / total) * 100 + "%",
      };
    },
    get_percentage(items, current_val, value) {
      let total = 0;
      items.forEach((key) => {
        total = total + value[key];
      });
      return Math.round((current_val / total) * 100) + "%";
    },
  },
  computed: {
    msg() {
      return this.$auth.error;
    },
  },
};
</script>
<style lang="scss" scoped>
.distribution-bar > div {
  opacity: 0.8;
}
</style>
